import * as React from 'react';
import TopNavAvatarWithActions from './TopNavAvatarWithActions';
import Notifications from './Notifications';
import './TopNav.css';
import TopNavBreadcrumb from './TopNavBreadcrumb';
import FlairButtonIcon from '../../../../atomic/molecules/FlairButtonIcon';
import { useIsScreenSizeLargerThanOrEqual } from '../../../../hooks/useIsScreenSizeLargerThan';
import { MenuBarContext } from '../../context/MenuBar';
import { useContext, useState, useCallback } from 'react';
import { CommandBar, useCommandBarKeyboard } from '../CommandBar';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';
import {
  AI_CHAT_FEATURE,
  useFeature,
} from '../../../../context/FeaturesContext';
import { useUserInfo } from '../../context/UserInfo';

const TopNav: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isLargeScreen = useIsScreenSizeLargerThanOrEqual('lg');
  const { isExpanded, setIsExpanded } = useContext(MenuBarContext);
  const [isCommandBarOpen, setIsCommandBarOpen] = useState(false);
  const { organizationSubscriptionInfo } = useUserInfo();
  // The command bar only surfaces for customers who have Flair AI enabled via
  // subscription. The aiChat feature flag stays as a rollout / kill switch.
  const isAiChatEnabled =
    useFeature(AI_CHAT_FEATURE) && organizationSubscriptionInfo?.ai === true;

  const toggleCommandBar = useCallback(() => {
    if (!isAiChatEnabled) return;
    setIsCommandBarOpen((prev) => !prev);
  }, [isAiChatEnabled]);

  useCommandBarKeyboard(toggleCommandBar);

  const handleClose = useCallback(() => {
    setIsCommandBarOpen(false);
  }, []);

  const onToggleMenuBar = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className="top-nav-container d-flex align-items-center position-sticky top-0"
      data-testid="TopNav">
      {isLargeScreen && <TopNavBreadcrumb />}
      {!isLargeScreen && (
        <FlairButtonIcon
          icon="hamburger-menu"
          onClick={onToggleMenuBar}
          size="xl"
          variant="text"
        />
      )}
      <div className="top-nav-actions d-flex align-items-center gap-4">
        {isAiChatEnabled && (
          <button
            className="top-nav-assistant-btn"
            onClick={toggleCommandBar}
            data-testid="command-bar-button">
            <FlairIcon icon="star-four-filled" size="sm" />
            <span>Assistant</span>
          </button>
        )}
        <Notifications />
        <TopNavAvatarWithActions />
      </div>

      {isCommandBarOpen && <CommandBar onClose={handleClose} />}
    </div>
  );
};

export default TopNav;
